import {useQuery} from 'react-query'
import {getKanbanTasks} from '../core/_requests'
import {useQueryRequest} from '../core/QueryRequestProvider'
import {stringifyRequestQuery} from '../../../../_metronic/helpers'

export function useGetDoneTasks({userId}: {userId?: string}) {
  const {state} = useQueryRequest()

  const fullQuery = stringifyRequestQuery(state)
  const filtersOnly = fullQuery
    .split('&')
    .filter((p: string) => p.startsWith('filter_') || p.startsWith('search='))
    .filter((p: string) => !p.startsWith('filter_status=') && !p.startsWith('filter_mode='))
    .join('&')
  const finalFilters = [filtersOnly, 'filter_status=entregue', `userId=${userId}`]
    .filter(Boolean)
    .join('&')

  return useQuery(
    ['tasks-by-user-kanban', finalFilters],
    async () => (await getKanbanTasks(finalFilters)).data ?? [],
    {
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      enabled: (state.filter as {mode: string}).mode == 'kanban',
    }
  )
}
